import React from 'react';
import { Flex, Text, Image } from '@chakra-ui/react';

export default function UnlockableTag() {
  return (
    <Flex bg="#012aff" pos="absolute" top={2} right={2} borderRadius={4} borderColor="#012aff" px={2} py={1}>
      <Text fontSize="10px" letterSpacing="2.22px" fontWeight="bold" color="#fff" mr="10px">
        UNLOCKABLE CONTENT
      </Text>
      <Image src="/images/fontisto-unlocked.svg" alt="" />
    </Flex>
  );
}
